import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { RequireAuth } from "./lib/auth";
import { InterviewDetail } from "./pages/InterviewDetail";
import { Interviews } from "./pages/Interviews";
import { Login } from "./pages/Login";
import { NotAuthorized } from "./pages/NotAuthorized";
import { Prompts } from "./pages/Prompts";
import { StudyDetail } from "./pages/StudyDetail";
import { Studies } from "./pages/Studies";

/**
 * Admin router (architecture §5.3).
 *
 * /login is the only public route. Everything else is wrapped in
 * <RequireAuth> + the <AppShell> sidebar.
 *
 * Routes:
 *   /                  → /studies
 *   /studies           list (My Studies)
 *   /studies/:id       detail + edit
 *   /interviews        list (Interviews database, cursor-paginated)
 *   /interviews/:id    detail (transcript, audio, insights, user details)
 *   /prompts           workspace prompts CRUD
 *   /login             Google sign-in
 */
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/not-authorized" element={<NotAuthorized />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Navigate to="/studies" replace />} />
        <Route path="/studies" element={<Studies />} />
        <Route path="/studies/:id" element={<StudyDetail />} />
        <Route path="/interviews" element={<Interviews />} />
        <Route path="/interviews/:id" element={<InterviewDetail />} />
        <Route path="/prompts" element={<Prompts />} />
        <Route path="*" element={<Navigate to="/studies" replace />} />
      </Route>
    </Routes>
  );
}
